import { Component, Input } from '@angular/core';

@Component({
  selector: 'muni-gameday-tab',
  templateUrl: './tab.template.html',
  styleUrls: ['./tab.component.scss'],
  standalone: false,
})
export class TabComponent {
  @Input()
  public header: string;

  @Input()
  public tooltip = '';

  @Input()
  public disabled = false;

  public active = false;
}
